import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TreeCardObject } from 'src/app/models/orders/tree-card/tree-card-object.model';
import { CrmOrderObject } from 'src/app/models/orders/crm-order/crm-order-object.model';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrderService } from 'src/app/services/api/orders/specific-order/order.service';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrderTree } from 'src/app/services/api/orders/orders.service';
import { ProductOrderObject } from 'src/app/models/orders/product-order/product-order-object.model';
import { CfsOrderObject } from 'src/app/models/orders/cfs-order/cfs-order-object.model';
import { RfsOrderObject } from 'src/app/models/orders/rfs-order/rfs-order-object.model';

@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.css']
})
export class TreeComponent implements OnInit, OnChanges {

  @Input() tree: OrderTree;
  @Input() params: any;

  treeCards: Array<TreeCardObject>;

  constructor(private orderService: OrderService) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tree) {
      this.tree = changes.tree.currentValue;
    }
    if (changes.params) {
      this.params = changes.params.currentValue;
    }
    this.ngOnInit();
  }

  ngOnInit() {
    this.loadTree(this.tree);
  }

  private loadTree(tree: OrderTree) {
    const crmOrderObject: CrmOrderObject = this.computeTree(tree, tree.crmId) as CrmOrderObject;
    this.treeCards = crmOrderObject.getRecursivityTreeCardList();
    this.setSelectedTreeCard(
      this.params.map ? this.params.map : this.tree.orderId,
      this.params.type ? this.params.type.toUpperCase() : 'CRM'
    );
  }

  private computeTree(treeNodeJSON: any, crmId: string): TreeCardObject {
    const treeNodeObject: TreeCardObject = this.createNode(treeNodeJSON, crmId);
    if (treeNodeObject !== undefined && treeNodeJSON.children !== undefined) {
      treeNodeJSON.children.forEach(async child => {
        const childNodeObject: TreeCardObject = this.computeTree(child, crmId);
        treeNodeObject.addChildren(childNodeObject);
      });
    }
    return treeNodeObject;
  }

  private createNode(treeNodeJSON: any, crmId: string): TreeCardObject {
    const type: OrderTypeObject = OrderTypeObject.createWithType(treeNodeJSON.type.name);
    switch (type) {
      case OrderTypeObject.CRM:
        return new CrmOrderObject(treeNodeJSON.name, treeNodeJSON.status,
          treeNodeJSON.orderId, treeNodeJSON.crmId);
      case OrderTypeObject.PRODUCT: return new ProductOrderObject(treeNodeJSON.name,
        treeNodeJSON.completed, crmId, treeNodeJSON.operation, treeNodeJSON.status,
        treeNodeJSON.dependencies, treeNodeJSON.orderId);
      case OrderTypeObject.CFS: return new CfsOrderObject(treeNodeJSON.name,
        treeNodeJSON.completed, crmId, treeNodeJSON.operation, treeNodeJSON.status,
        treeNodeJSON.dependencies, treeNodeJSON.orderId);
      case OrderTypeObject.RFS: return new RfsOrderObject(treeNodeJSON.name,
        treeNodeJSON.completed, crmId, treeNodeJSON.operation, treeNodeJSON.status,
        treeNodeJSON.dependencies, treeNodeJSON.orderId);
    }
    return new TreeCardObject(treeNodeJSON.name, '', '', treeNodeJSON.completed, treeNodeJSON.orderId, treeNodeJSON.operation,
      treeNodeJSON.status, treeNodeJSON.dependencies, 0, treeNodeJSON.orderId, OrderTypeObject.PRODUCT);
  }

  onClickCard($event: TreeCardObject) {
    this.setSelectedTreeCard($event.getOrderId(), $event.getType().name);
  }

  setSelectedTreeCard(map: string, type: string) {
    for (let treeCard of this.treeCards) {
      if (treeCard.getOrderId() === map && treeCard.getType().name === type) {
        treeCard.setClicked(true);
      } else {
        treeCard.setClicked(false);
      }
    }
  }
}
